/* eslint-disable */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Draft from '../../../components/Draft';
import React, { createContext,  useState } from 'react';
import FileUpload from '../../../components/FileUpload';
import { useEffect } from 'react';
import RadioGroup from '../../../components/RadioGroup';
import { useContext } from 'react';
import { ConfigContext } from '../../../providers/ConfigProvider';

import IconCheck from '../../../components/IconCheck';
import PersonModal from '../../../components/PersonModal';
import Drawer from '../../../components/Drawer';
import { AuthContext } from '../../../providers/AuthProvider';
import UserPhoto from '../../../components/UserPhoto';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { DomainContext } from '../../../providers/DomainProvider';
import FormBuilderProvider from '../../../components/FormBuilder';
import SubtaskProvider from '../../../components/Subtask';
import Input from '../../../components/Input';
import * as yup from 'yup';
import { useFormik } from 'formik';
import TaskRepetition from '../../../components/TaskRepetition';
import PersonPicker from '../../../components/PersonPicker';
import BoxLoading from '../../../components/BoxLoading';
import { CompanyContext } from '../../../providers/CompanyProvider';

const Context = createContext({
    form: {},
    subtasks: [],
    addSubTask: () => {},
    setForm: () => {},
    createTask: () => {},
})

const Provider = ({children}) => {
    const { apiCall } = useContext(AuthContext)
    const { notify } = useContext(ConfigContext)
    const { hasCompanyPermission } = useContext(CompanyContext)

    const [task, setTask] = useState(null)
    const [form, setForm] = useState({})
    const [subtasks, setSubtasks] = useState([])
    
    const navigate = useNavigate()
    const params = useParams()

    const loadTask = async (id) => {
        if(params.id){
            const { data } = await apiCall({action: 'get-task-edit-details', id: params.id})
            if(data.status === 1){
                setTask(data.data)
                setSubtasks(data.data.subtasks)
                setForm(data.data.form ? data.data.form : {})
            }
        }
    }
    
    useEffect(() => {
        if(params.id){
            loadTask()
        }
    }, [])

    return <Context.Provider value={{
        task,
        form,
        subtasks,
        addSubTask: (task, index) => {
            if(index === -1){
                setSubtasks([...subtasks, task])
            }else{
                const newSubTasks = subtasks
                newSubTasks[index] = task
                setSubtasks(newSubTasks)
            }
        },
        setForm: (form) => {
            setForm(form)
        },
        createTask: async (taskData) => {
            
            const status = await apiCall({
                action: 'edit-domain-task',
                id: task.id,
                name: taskData.name,
                files: taskData.files,
                description: taskData.description,
                signature: taskData.signature,
                priority: taskData.priority,
                interval: taskData.interval,
                responsible: taskData.responsible,
                form: form ? form : null,
                subtasks: subtasks ? subtasks : null,
            })

            notify(status.data.status, 'Suksess!', status.data.message)

            if(status.data.status === 1){
                navigate(-1)
            }

        }
    }}>{task ? ( hasCompanyPermission('adminTask') ? children : <NoAccess />) : <BoxLoading customText="Henter oppgavedetaljer" />}</Context.Provider>
}


function NoAccess(){

    const navigate = useNavigate()

    return (
        <div className="py-5 d-flex flex-column justify-content-center align-items-center h-100">
            <div className="box d-flex flex-column justify-content-center align-items-center p-5">
            <div className="bg-danger mb-3" style={{width: 90, height: 90, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <FontAwesomeIcon fixedWidth size="3x" icon={['fad', 'xmark']} className="text-white" />
            </div>
            <div className="text-center">
                <h3 className="bold text-primary">Ingen tilgang</h3>
                <p>Du har ikke tilgangen som kreves for å redigere oppgaver</p>
                <button className="btn btn-primary" onClick={() => navigate(-1)}>Tilbake</button>
            </div>
            </div>
        </div>
    )
}


export default function CompanyTaskEdit(){
    return (
        <Provider>
            <CreateTask />
        </Provider>
    )
}

function CreateTask(){
    const { form, subtasks, task, createTask } = useContext(Context)
    const { companyUsers, consultants } = useContext(CompanyContext)
    const navigate = useNavigate()
    const [personModalOpen, setPersonModalOpen] = useState(false)

    const [formDrawerOpen, setFormDrawerOpen] = useState(false)
    const [subTaskDrawerOpen, setSubTaskDrawerOpen] = useState(false)

    let schema = yup.object().shape({
        name: yup.string().required("Oppgavenavn er påkrevd"),
    });


    const formik = useFormik({
        initialValues: {
            name: task.name,
            priority: task.priority,
            signature: task.signature,
            interval: task.interval,
            description: task.description,
            responsible: task.responsible,
            files: task.files
        },
        validationSchema: schema,
        onSubmit: async (values) => {  
                     
            saveTask(values)
        },
    });

	
    


    const saveTask = (data) => {
        createTask({
            name: data.name,
            files: data.files,
            description: data.description,
            interval: data.interval,
            signature: data.signature,
            priority: data.priority,
            responsible: data.responsible,
            form: form,
            subtasks: subtasks
        })
    }
    return (
        <div className="p-md-3 p-2">
            <div className="box p-md-4 p-3">
                <h3 className="bold mb-md-5 mb-2">Rediger oppgave</h3>
                <hr/>
                <div className="row gx-1 mb-3">
                    <div className="col-auto mb-1">
                        <div onClick={() => setFormDrawerOpen(true)} className="border p-3 pointer" style={{borderRadius: '5px'}}>
                            <div className="row gx-md-3 gx-2 align-items-center">
                                <div className="col-auto">
                                    <FontAwesomeIcon className={Object.keys(form).length ? "text-primary" : ""} size='2x' icon={['fal', 'clipboard']} />
                                </div>
                                <div className="col">
                                    <h6 className='bold m-0'>Skjema</h6>
                                    
                                    {
                                        Object.keys(form).length ? <i>Rediger skjema</i>
                                        : <i className="hint-text">Legg til skjema</i>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div onClick={() => setSubTaskDrawerOpen(true)} className="border p-3 pointer" style={{borderRadius: '5px'}}>
                            <div className="row gx-md-3 gx-2 align-items-center">
                                <div className="col-auto">
                                    <FontAwesomeIcon className={subtasks?.length ? "text-primary" : ""} size='2x' icon={['fal', 'network-wired']} />
                                </div>
                                <div className="col">
                                    <h6 className='bold m-0'>Underoppgaver</h6>
                                    {
                                        subtasks?.length ? <i>{subtasks?.length} underoppgaver</i>
                                        : <i className="hint-text">Legg til</i>
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={formik.handleSubmit}>
                <div className="row">
                    <div className="col-lg-8">
                        <Input
                            name="name"
                            label="Navn"
                            type="text"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            touched={formik.touched.name}
                            helperText={formik.touched.name && formik.errors.name}
                            placeholder={"Navn på oppgave"}
                        />
                        <div className="form-group mb-3">
                            <label>Beskrivelse</label>
                            <Draft
                                value={formik.values.description}
                                setValue={(e) => formik.setFieldValue('description', e)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Vedlegg</label>
                            <FileUpload
                                files={formik.values.files}
                                setFiles={(e) => formik.setFieldValue('files', e)}
                            />
                        </div>
                    </div>
                    
                    <div className="col">
                        <div className="form-group mb-3">
                            <label>Velg ansvarlig</label>
                            <PersonPicker
                                items={[...companyUsers, ...consultants]}
                                selected={formik.values.responsible}
                                setSelected={(e) => formik.setFieldValue('responsible', e)}
                            />
                            
                            
                        </div>
                        <div className="form-group mb-3">
                            <label>Signering</label>
                            <RadioGroup
                                items={[
                                    {label: 'Ingen signering', value: 1},
                                    {label: 'Krev signatur av ansvarlige', value: 2},
                                ]}
                                selected={formik.values.signature}
                                select={(e) => formik.setFieldValue('signature', e)}
                            />
                        </div>
                        <div className="form-group mb-3">
                            <label>Prioritet</label>
                            <IconCheck
                                checked={formik.values.priority}
                                setChecked={(e) => formik.setFieldValue('priority', e)}
                                icon="flag"
                                color="danger"
                                classes="mb-2"
                            />
                            <p><i>{ formik.values.priority ? 'Oppgaven er merket som prioritert' : 'Oppgaven har ingen spesiell prioritet'} </i></p>
                        </div>
                        <TaskRepetition 
                            value={formik.values.interval}
                            setValue={(e) => formik.setFieldValue('interval', e)}
                        />
                    </div>
                </div>
                <div className="row mt-5 justify-content-center">
                    
                    <div className="col-md-5 col">
                        <div className="d-grid">
                            <button type="submit" className="btn btn-primary d-block">Lagre oppgave</button>
                        </div>
                    </div>
                </div>
                </form>
                <Drawer open={formDrawerOpen} setOpen={setFormDrawerOpen} >
                    <FormBuilderProvider currentContext={Context} />     
                </Drawer>
                <Drawer open={subTaskDrawerOpen} setOpen={setSubTaskDrawerOpen}>
                    <SubtaskProvider TaskContext={Context} />        
                </Drawer>
            </div>
        </div>
    )
    
}



